import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import InternalNotes from '../internal-notes/internal-notes';
import { SectionContainer } from './styles';
import type { InternalNotesForm } from './types';

interface InternalNotesElementProps {
  form: InternalNotesForm;
}

const InternalNotesElement = ({ form }: InternalNotesElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <InternalNotes />
    </FormProvider>
  </SectionContainer>
);

export default memo(InternalNotesElement);
